import { render, staticRenderFns } from "./GoodsReceiveItem.vue?vue&type=template&id=5b5b4cab&scoped=true"
import script from "./GoodsReceiveItem.vue?vue&type=script&lang=js"
export * from "./GoodsReceiveItem.vue?vue&type=script&lang=js"
import style0 from "./GoodsReceiveItem.vue?vue&type=style&index=0&id=5b5b4cab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b4cab",
  null
  
)

export default component.exports